import {
  AHIcon,
  AHText,
  Box,
  ListItem,
  TouchableBox,
  useLayoutContext,
} from "arkh";
import React from "react";
import { graphql, useFragment, useMutation } from "react-relay";
import { useIntlTokens } from "../../../../../components/mobile/useIntlTokens";
import { LinkedWorkspaceProductItem } from "../../../../../components/LinkedContent/LinkedWorkspaceProductItem";
import { WorkspaceTodoEditMainProducts_TodoWorkspace$key } from "./__generated__/WorkspaceTodoEditMainProducts_TodoWorkspace.graphql";
import { WorkspaceTodoEditMainProductsUnLinkMutation } from "./__generated__/WorkspaceTodoEditMainProductsUnLinkMutation.graphql";

export function WorkspaceTodoEditMainProducts(props: {
  todo: WorkspaceTodoEditMainProducts_TodoWorkspace$key;
  openLinkProduct?(params: {
    linkedProductIds: string[];
    todoWorkspaceId: string;
  }): void;
  openProduct(id: string): void;
  disabled?: boolean;
}) {
  const intl_tokens = useIntlTokens();
  const layout = useLayoutContext();
  const todo = useFragment(
    graphql`
      fragment WorkspaceTodoEditMainProducts_TodoWorkspace on TodoWorkspace {
        id
        linkedProducts {
          id
          ...LinkedWorkspaceProductItem_WorkspaceProduct
        }
      }
    `,
    props.todo
  );

  const [unLinkProduct] =
    useMutation<WorkspaceTodoEditMainProductsUnLinkMutation>(graphql`
      mutation WorkspaceTodoEditMainProductsUnLinkMutation(
        $productId: ID!
        $todoWorkspaceId: ID!
      ) {
        todoWorkspace(id: $todoWorkspaceId) {
          unlinkProduct(productId: $productId) {
            id
            linkedProducts {
              id
            }
          }
        }
      }
    `);

  return (
    <>
      <ListItem
        isFirst
        color={props.disabled ? "transparent" : "surface-primary"}
        border="border-primary"
        isLast={todo.linkedProducts.length === 0}
        disabled
        left={<AHIcon type="product" color="text-secondary" />}
        right={
          props.disabled ? null : (
            <TouchableBox
              borderColor="border-primary"
              cornerRadius="medium"
              spaceHorizontal="small"
              disabled={props.disabled}
              style={{
                height: layout.circle.smallMedium,
                borderWidth: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
              onPress={() => {
                props.openLinkProduct?.({
                  linkedProductIds: todo.linkedProducts.map((v) => v.id),
                  todoWorkspaceId: todo.id,
                });
              }}
            >
              <AHText>{intl_tokens.AddProduct}</AHText>
            </TouchableBox>
          )
        }
      >
        <ListItem.TitleSecondary>
          {intl_tokens.Products}
        </ListItem.TitleSecondary>
      </ListItem>
      {todo.linkedProducts.length > 0 ? (
        <Box
          color={props.disabled ? "transparent" : "surface-primary"}
          borderColor="border-primary"
          style={{
            borderWidth: 1,
            borderTopWidth: 0,
          }}
          cornerRadiusBottomLeft="large"
          cornerRadiusBottomRight="large"
        >
          <Box
            style={{
              paddingRight: layout.space.medium,
              paddingBottom: layout.space.medium,
              flexDirection: "row",
              justifyContent: "flex-end",
              flexWrap: "wrap",
            }}
          >
            {todo.linkedProducts.map((product) => (
              <Box
                key={product.id}
                spaceTop="medium"
                spaceLeft="medium"
                style={{ maxWidth: "100%" }}
              >
                <LinkedWorkspaceProductItem
                  product={product}
                  onPressProduct={(id) => {
                    props.openProduct(id);
                  }}
                  unLinkProduct={
                    props.disabled
                      ? undefined
                      : (id) => {
                          unLinkProduct({
                            variables: {
                              todoWorkspaceId: todo.id,
                              productId: id,
                            },
                          });
                        }
                  }
                />
              </Box>
            ))}
          </Box>
        </Box>
      ) : null}
    </>
  );
}
